module.exports = __webpack_public_path__ + "img/atendimento.c3dc571f.png";